module.exports = __webpack_public_path__ + "img/customer_design_5@2x.ee826e4.webp";